var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[(!['home', 'login'].includes(_vm.currentRouter))?_c('cmp-header',{attrs:{"type":2}}):_vm._e(),(_vm.viewFlag || ['login'].includes(_vm.currentRouter))?_c('router-view'):_vm._e(),_c('myfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }